import WizardDialog, { WizardModalDialogProps } from "designSystem/components/wizard/WizardDialog";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { MassUpdateBOMWizardStoreContext, MassUpdateWizardStore } from "csi/store/MassUpdateWizardStore";
import MassUpdateSettingsForm from "./MassUpdateSettingsForm";
import { MassUpdateLinkedBOMsTable } from "./MassUpdateLinkedBOMsTable";

export const MassUpdateBOMWizard: FunctionComponent<WizardModalDialogProps<MassUpdateWizardStore>> = observer((props) => {
	const {
		store,
		...otherProps
	} = props;
	
	const { index } = store || {};

	return (
		<>
			{store && (
				<MassUpdateBOMWizardStoreContext.Provider value={store}>
					<WizardDialog
						{...otherProps}
						contentPadding={index === 0 ? null : 0}
						// do this to prevent the MUI event from disabling the event of Dojo widget, for example, in the case of Form, when we try to select a value from drop-down, 
						// the focus event from MUI would disable the onMouseUp event of FilteringSelect widget
						disableEnforceFocus
						fullHeight
						pages={[ MassUpdateSettingsForm, MassUpdateLinkedBOMsTable]}
						store={store}
						supportStepInformation
						width={index === 1 ? 1200 : 720}
					/>
				</MassUpdateBOMWizardStoreContext.Provider>
			)}
		</>
	);
});

export default MassUpdateBOMWizard;